import * as UI from "@iyk/music-ui"

export type WorldAvatarProps = {
  url: string
  name: string
  size: UI.ArtistAvatarProps["size"]
}

export const WorldAvatar = ({ url, name, size }: WorldAvatarProps) => {
  return <UI.ArtistAvatar url={url} size={size} name={name} />
}
